// extracted by mini-css-extract-plugin
export var radioInputRow = "x_st";
export var radioInputColumn = "x_sv";
export var inputOptionRow = "x_qq";
export var inputOptionColumn = "x_qr";